<div #linkWrapper>
  <ng-content select=".sidenav-subheading"></ng-content>
  <ng-content select=".sidenav-link"></ng-content>
</div>
<ng-content select=".sidenav-collapse"></ng-content>
